import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import phiveRetPlugin from './phiveRetPlugin.js'; 

//import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap'
import './assets/font.css';

//import '@fortawesome/fontawesome-free/css/all.css'

const app = createApp(App);
app.use(phiveRetPlugin);
//app.config.globalProperties.PhiveHost = 'https://ec2-34-227-162-106.compute-1.amazonaws.com/';
app.config.globalProperties.PhiveHost = 'https://clouds.selfip.com/';
//app.config.globalProperties.PhiveHost = 'http://macgen.kramxel.com';
app.use(router);
app.mount('#app');

